import styled from 'styled-components';
import { LG_THRESHOLD, XL_THRESHOLD } from 'constants/ScreenDimensions';

export const Wrapper = styled.div`
  background: #f9f9fb;
  border-radius: 4px;
  padding: ${({ noPaddingBottom }) =>
    noPaddingBottom ? '16px 16px 0 16px' : '16px'};
`;

export const StyledToggleButton = styled.button`
  background: #ffffff;
  border: 1px solid #dfe3ec;
  border-radius: 2px;
  color: #33373d;
  font-size: 14px;
  line-height: 16px;

  :focus {
    outline: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  margin: 0 auto;
  display: block;

  svg {
    margin-right: 6px;
  }
`;

export const TemplateWrapper = styled.div`
  height: ${({ width }) => {
    if (width >= XL_THRESHOLD) return 120;
    if (width >= LG_THRESHOLD) return 70;
    return 10;
  }}px;
  display: table;
  width: 100%;
  margin-bottom: 24px;

  .radio-container {
    display: table-cell;
    min-width: ${({ width }) => {
      if (width > LG_THRESHOLD) return 200;
      return 150;
    }}px;
    vertical-align: middle;
  }

  .radio-container > label {
    margin-left: 8px;
  }

  .banner {
    display: table-cell;
    vertical-align: middle;
  }
`;

export const StyledRadioLabel = styled.label`
  margin: 0px 8px;
  color: #33373d;
`;
